function e(e){return void 0===e?"":e.replace(/\|/g,"/")}export{e as default};
